import { NameDto } from '@model/NameDto'

export interface RewardProgramDto {
  id: string
  internalName: string
  programStatus: NameDto
  trackingMetrics: NameDto[]
  numberOfTiers: number
}

export interface RewardProgramDetailsDto {
  rewardProgramInfo: {
    id: string
    internalName: string
    displayName: string
    description: string
    rewardStatus: NameDto
    displayOrder: number
    resetCadence: NameDto
    icon: NameDto | null
    startDate: string
    endDate: string
    termsAndConditionsUrl: string
    numberOfTiers: number
    lastModified: string
    companies: NameDto[]
    countries: NameDto[]
    tiers: RewardProgramDetailsTierDto[]
  }
  spins: {
    luckyDrawCampaign: NameDto
    rewardProgramTier: NameDto<string>
    numberOfSpins: number
  }[]
  tradingViewPlan: { tradingViewPlanCampaign: NameDto | null; rewardProgramTier: NameDto | null }
}

export interface RewardProgramEligibilityCheckDto {
  rewardWidgetState: NameDto
  rewardProgramTier: NameDto<string>
}

export interface RewardProgramDetailsTierDto {
  id: string
  tierNumber: number
  name: string
  trackingMetric: NameDto
  rewardProgramTierConditionLogin: NameDto
  thresholdValue: number
  currentValue: number
  currency: NameDto<string>
  reward: NameDto
  callToActionText: string
  metrics: RewardProgramDetailsTierMetricDto[]
}

export interface RewardProgramDetailsTierMetricDto {
  id: string
  rewardProgramTierLogicalOperator: NameDto
  trackingMetric: NameDto
  rewardProgramTierConditionLogicId: number
  value: number
  currentValue: number
  currency: NameDto<string>
}

export enum RewardWidgetStatus {
  IN_PROGRESS = 1,
  READY_TO_CLAIM = 2,
  CLAIMED = 3,
  ENDED = 4,
}

export enum RewardProgramStatus {
  ACTIVE = 1,
  DISABLED = 2,
}

export enum RewardTrackingMetricType {
  TRADING_VOLUME = 1,
  NET_DEPOSIT_VALUE = 2,
  BALANCE = 3,
}

export enum MetricBarStatus {
  CLAIMED = 'claimed',
  LOCKED = 'locked',
  COMPLETED = 'completed',
  CURRENT = 'current',
}

export enum RewardResetCadence {
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
  QUARTERLY = 4,
  ANNUALLY = 5,
  LIFETIME = 6,
}

export enum RewardProgramIcon {
  MIXED = 1,
  SPINS = 2,
  TRADING_VIEW = 3,
}
